import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import { SessionHelper } from "app/helpers/sessionHelper";
import React from "react";
import { FormattedMessage } from "react-intl";
import ENV from "../../../../../../config";

const PublicLoginRegister = () => {
  return (
    <React.Fragment>
      <a
        href={`${
          SessionHelper.isAuthenticated()
            ? ENV.MAIN_SITE_URL + "/login"
            : "login"
        } `}
        className="nav-bar__nav-item--login"
      >
        <span className="nav-bar__nav-item--login-text">
          <FormattedMessage tagName="span" id="login-login" />
        </span>
      </a>
      <a
        href={`${ENV.MAIN_SITE_URL + "/register"} `}
        className="nav-bar__nav-item--contact"
        id="signUp" // Added an ID to the register link for easier targeting
      >
        {ENV.CSS_THEME === "DEFAULT" && (
          <div className="nav-bar__nav-item--contact__text">
            <FormattedMessage tagName="span" id="home-cta-register" />
          </div>
        )}
      </a>
      {/* Adding GeniusSiteTracking outside the links but targeting the register link */}
      <GeniusSiteTracking
        targetSelector="#signUp"
        eventType="click"
        pageName="regstart"
        trackPageLoad={false}
      />
    </React.Fragment>
  );
};

export default PublicLoginRegister;
